module.exports = __webpack_public_path__ + "1cd43b68c59253fb4debefb9cf6a6237.png";